
export const FETCH_RAWITEMS_REQUEST = "FETCH_RAWITEMS_REQUEST";
export const FETCH_RAWITEMS_SUCCESS = "FETCH_RAWITEMS_SUCCESS";
export const FETCH_RAWITEMS_FAILURE = "FETCH_RAWITEMS_FAILURE";

export const CREATE_RAWITEM_REQUEST = "CREATE_RAWITEM_REQUEST";
export const CREATE_RAWITEM_SUCCESS = "CREATE_RAWITEM_SUCCESS";
export const CREATE_RAWITEM_FAILURE = "CREATE_RAWITEM_FAILURE";

export const UPDATE_RAWITEM_REQUEST = "UPDATE_RAWITEM_REQUEST";
export const UPDATE_RAWITEM_SUCCESS = "UPDATE_RAWITEM_SUCCESS";
export const UPDATE_RAWITEM_FAILURE = "UPDATE_RAWITEM_FAILURE";

export const DELETE_RAWITEM_REQUEST = "DELETE_RAWITEM_REQUEST";
export const DELETE_RAWITEM_SUCCESS = "DELETE_RAWITEM_SUCCESS";
export const DELETE_RAWITEM_FAILURE = "DELETE_RAWITEM_FAILURE";
